import React from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { PageTitleWrapperS } from '../../components/RightSideBar/RightSideBarStyles';
import { Alert, DefaultSelect, Loader } from '../../components/ui';
import {
  ButtonBorderedS,
  ButtonDefS,
} from '../../components/ui/buttons/styles';
import { SelectItemType } from '../../components/ui/selects/DefaultSelect';
import { TWorkspace } from '../../store/workspaces/types';
import { API_ROUTE_PATH } from '../../utils/api_routes';
import { callApi } from '../../utils/callApi';
import { ROUTE_PATH } from '../../utils/routes';
import { TEXT } from '../../utils/textConst';
import {AssessmentIcon} from "../../components/svgs";
import {useRawData} from "../../pages/admin/hooks/useRawData";
import {ALL_GROUPS_TYPES, ALL_GROUPS_TYPES_RAW_DATA} from "../../utils/consts";
import {ParticipantSources} from "../../store/groups/types";
import {deepClone} from "../../utils/deepClone";

interface RawDataReportProps {
  data: [];
}

export const RawDataReport: React.FC<RawDataReportProps> = () => {
  const [isLoadingTeam, setIsLoadingTeam] = React.useState(true);

  const [isLoadingWorkspace, setIsLoadingWorkspace] = React.useState(true);

  const [errorText, setErrorText] = React.useState('');
  const [selectPackage, setSelectPackage] = React.useState<SelectItemType[]>([]);
  const [selectAssessment, setSelectAssessment] = React.useState<SelectItemType[]>([]);
  const [selectCycle, setSelectCycle] = React.useState<SelectItemType[]>([]);
  const [isLoadingOriginSource, setIsLoadingOriginSource] = React.useState(true);
  const [isLoadingPackage, setIsLoadingPackage] = React.useState(true);
  const [isLoadingAssessment, setIsLoadingAssessment] = React.useState(true);
  const [isLoadingCycle, setIsLoadingCycle] = React.useState(true);
  const [step, setStep] = React.useState(1);
  const [stepNotPage, setStepNotPage] = React.useState(1);

  const history = useHistory();

  const {
    selectTeams,
    setSelectTeams,
    selectedTeam,
    setSelectedTeam,
    selectWorksapces,
    setSelectWorksapces,
    selectedWorkspace,
    setSelectedWorkspace,
    selectedOriginSource,
    setSelectedOriginSource,
    selectOriginSource,
    setSelectOriginSource,
    selectedPackage,
    selectedAssessment,
    setSelectedCycles,
    setSelectedPackage,
    setSelectedAssessment,
    activeCyclesLinks,
    genCSV,
    isLoading,
  } = useRawData();


  const getTeams = async () => {
    interface ITeamsData {
      id: string;
      name: string;
    }

    try {
      setIsLoadingTeam(true)
      setErrorText('');
      const data = (await callApi({
        path: API_ROUTE_PATH.admins.teamsPath,
        method: 'get',
      })) as ITeamsData[];

      if (
          !(data && Array.isArray(data) && data[0] && data[0].id && data[0].name)
      ) {
        console.log(data, 'error data');
        return setErrorText(TEXT.someError);
      }

      const newTeams: typeof selectTeams = [];

      data.forEach((itm) => {
        newTeams.push({
          title: itm.name,
          value: itm.id,
          id: itm.id,
        });
      });
      return setSelectTeams(newTeams);
    } catch (e) {
      setErrorText(`${e}`);
      window.location.href = '/';
    } finally {
      setIsLoadingTeam(false);
    }
  };

  const getWorkspaces = async (item: SelectItemType) => {
    if (!item?.id)
      return setErrorText('No Team id, ' + TEXT.tryLater);
    try {
      setErrorText('');
      setSelectedTeam(item)
      setIsLoadingWorkspace(true)
      setStepNotPage(2)
      const data = (await callApi({
        path: API_ROUTE_PATH.admins.workspacesPath(item.id as string),
        method: 'get',
      })) as TWorkspace[];

      if (
          !(data && Array.isArray(data) && data[0] && data[0].id && data[0].name)
      ) {
        console.log(data, 'error data');
        return setErrorText(TEXT.someError);
      }

      const newWorkspaces: typeof selectWorksapces = [];

      data.forEach((itm) => {
        newWorkspaces.push({
          title: itm.name,
          value: itm.id,
          id: itm.id,
        });
      });
      return setSelectWorksapces(newWorkspaces);
    } catch (e) {
      setErrorText(`${e}`);
      window.location.href = '/';
    } finally {
      setIsLoadingWorkspace(false);
    }
  };

  const getPackages = async (item: SelectItemType) => {
    if (!item?.id)
      return setErrorText('No Workspace id, ' + TEXT.tryLater);
    try {
      setErrorText('');
      setSelectedWorkspace(item)
      setIsLoadingPackage(true)
      setStepNotPage(3)
      const data = (await callApi({
        path: `${API_ROUTE_PATH.admins.getPackagesAnsweredByWorkspace(
            item.id as string,
            false
        )}`,
        method: 'get',
      })) as {
        id: string;
        name: string;
      }[];

      if (!Array.isArray(data))
        return setErrorText('Wrang format API data, ' + TEXT.tryLater);
      const newSelectData: SelectItemType[] = [];

      data.forEach((itm) => {
        let name = itm.name;
        if (
            data.find(
                (pkg) => pkg.name === itm.name && pkg.id !== itm.id
            )
        )
          name = `${itm.name}`;
        newSelectData.push({
          title: name,
          value: itm.id,
          id: itm.id,
        });
      });
      setSelectPackage(newSelectData);
    } catch (e) {
      setErrorText(`${e}`);
    } finally {
      setIsLoadingPackage(false);
    }
  };

  const PREF = ' (archived)';

  const getAss = async (itm:  SelectItemType) => {
    if (!itm?.id)
      return setErrorText('No Package id, ' + TEXT.tryLater);
    try {

      setSelectAssessment(null);
      setSelectedAssessment(null);
      setIsLoadingAssessment(true)
      setSelectedPackage(itm)
      setStepNotPage(4)
      const resp = (await callApi({
        path: `${API_ROUTE_PATH.admins.getAssessmentsAnsweredByWorkspace(
            selectedWorkspace.id as string,
            itm.id as string,
        )}`,
        method: 'get',
      })) as {
        id: string;
        name: string;
        is_archived: boolean;
        version: string;
      }[];
      if (!Array.isArray(resp))
        return setErrorText('Wrang format API data, ' + TEXT.tryLater);
      const newSelectData: SelectItemType[] = [];
      resp.forEach((itm) => {
        let name = itm.name;
        if (
            resp.find(
                (ass) => ass.name === itm.name && ass.id !== itm.id && ass.version
            )
        )
          name = `${itm.name} ${itm.version}`;
        newSelectData.push({
          title:  !itm.is_archived ? name : name + PREF,
          value: itm.id,
          id: itm.id,
        });
      });

      setSelectAssessment(newSelectData);
    } catch (error) {
      setErrorText(`${error}`);
    } finally {
      setIsLoadingAssessment(false);
    }
  };

  const getCycles = async (item: SelectItemType) => {
    if (!item?.id)
      return setErrorText('No Package id, ' + TEXT.tryLater);
    try {
      setIsLoadingCycle(true);
      setSelectedAssessment(item)
      setStepNotPage(6)
      const resp = (await callApi({
        path: `${API_ROUTE_PATH.admins.getAnsweredCyclesByWorkspace(
            selectedWorkspace.id as string,
            selectedPackage.id as string,
            item.id as string,
            false
        )}`,
        method: 'get',
      })) as {
        from: string;
        to: string;
        is_forever_package: boolean;
        link: string;
      }[];

      if (!Array.isArray(resp))
        return setErrorText('Wrang format API data, ' + TEXT.tryLater);

      const newCycles: SelectItemType[] = [];
      var links: string[] = [];
      resp.forEach((itm) => {
        const dateFrom = new Date(itm.from);
        const dateTo = new Date(itm.to);
        const dateNow = new Date();
        const dateNull = new Date('0001-01-01T00:00:00Z');

        const dateFromString = `${dateFrom.getMonth()+1}/${dateFrom.getDate()}/${dateFrom.getFullYear()}`
        const dateToString = `${dateTo.getMonth()+1}/${dateTo.getDate()}/${dateTo.getFullYear()}`

        let dateString = dateFromString

        if ((dateNow < dateTo) || (dateTo.getTime() === dateNull.getTime() && itm.is_forever_package)) {
          dateString += ' to current'
        }
        if (dateNow > dateTo && (dateTo.getTime() !== dateNull.getTime() && !itm.is_forever_package)) {
          dateString += ' to ' + dateToString;
        }

        newCycles.push({
          title: dateString,
          value: itm.link,
          id: itm.link,
        });
        links.push(itm.link)
      });

      setSelectedCycles(links);
      setSelectCycle(newCycles);
    } catch (error) {
      setErrorText(`${error}`);
    } finally {
      setIsLoadingCycle(false);
    }
  };

  const callOriginSources = async (item: SelectItemType) => {
    if (!item?.id)
      return setErrorText('No select Origin Source, ' + TEXT.tryLater);

    try {
      setIsLoadingOriginSource(true);
      setSelectedOriginSource([ALL_GROUPS_TYPES_RAW_DATA])
      const resp = (await callApi({
        path: `${API_ROUTE_PATH.admins.gOriginSources(
            selectedWorkspace.id as string,
        )}`,
        method: 'get',
      })) as {
        origin_sources: string[];
      };

      if (!Array.isArray(resp.origin_sources))
        return setErrorText('Wrang format API data, ' + TEXT.tryLater);
      const newSelectData: SelectItemType[] = [ALL_GROUPS_TYPES_RAW_DATA];

      resp.origin_sources.forEach((itm) => {
        newSelectData.push({
          title: ParticipantSources[itm],
          value: itm,
          id: itm,
        });
      });

      setSelectOriginSource(newSelectData);
    } catch (error) {
      setErrorText(`${error}`);
    } finally {
      setIsLoadingOriginSource(false);
    }
  };

  React.useEffect(() => {
    setIsLoadingTeam(true);
    getTeams();
    // eslint-disable-next-line
  }, []);

  const originSourceSelectHandler = (data: SelectItemType) => {
    if (
        data.value === ALL_GROUPS_TYPES.value &&
        selectedOriginSource[0].value === ALL_GROUPS_TYPES.value
    ) {
      return null;
    }
    const newData = deepClone(selectedOriginSource) as SelectItemType[];
    const originSources: SelectItemType[] = [];

    if (data.value === ALL_GROUPS_TYPES.value) {
      setSelectedOriginSource([ALL_GROUPS_TYPES]);
      setSelectedOriginSource([ALL_GROUPS_TYPES])
      return
    }

    let hasVal = false;

    if (newData[0] && newData[0].value === ALL_GROUPS_TYPES.value) {
      newData.splice(0, 1);
    }

    newData.forEach((itm, i) => {
      if (itm.value === data.value) {
        newData.splice(i, 1);
        hasVal = true;
      }
    });

    if (!hasVal) {
      newData.push(data);
    }

    newData.forEach((itm) => {
      if (itm.value !== ALL_GROUPS_TYPES.value) {
        originSources.push(itm);
      }
    });

    if (!newData[0]) {
      newData.push(ALL_GROUPS_TYPES);
    }

    setSelectedOriginSource(newData);
    return
  };


  const clickHandler = (currentStep: number) => {
    switch (currentStep) {
      case 1: {
        setStep(currentStep + 1);
        return;
      }
      case 2: {
        setStep(currentStep + 1);
        return;
      }
    }
  };

  const renderBody = () => {
    switch (step) {
      case 1: {
        return (
            <div>
              <MainBodyWrapper>
                <FirstSelectGroupWrapper>
                  <DefaultSelect
                      key={'one'}
                      isDisabled={false}
                      data={selectTeams}
                      onChange={getWorkspaces}
                      selected={selectedTeam}
                      label={'Team'}
                      placeHolder={'Select Team'}
                      isSearch={true}
                      isLoading={isLoadingTeam}
                  />

                  <DefaultSelect
                      key={'two'}
                      isDisabled={stepNotPage < 2}
                      data={selectWorksapces}
                      onChange={getPackages}
                      selected={selectedWorkspace}
                      label={'Workspace'}
                      placeHolder={'Select Workspace'}
                      isSearch={true}
                      isLoading={isLoadingWorkspace && stepNotPage === 2}
                  />
                </FirstSelectGroupWrapper>
              </MainBodyWrapper>
              <ButtonDefS
                  onClick={() => {
                    clickHandler(step);
                  }}
                  disabled={
                    (step === 1 &&
                        (!selectedTeam || !selectedWorkspace || !!errorText))
                  }
                  style={{ maxWidth: '97px' }}
              >
                Next
              </ButtonDefS>
            </div>
        );
      }

      case 2: {
        return (
            <div>
              <MainBodyWrapper>
                <FirstSelectGroupWrapper>
                  <DefaultSelect
                      key={'three'}
                      isDisabled={stepNotPage < 3}
                      data={selectPackage}
                      icon={AssessmentIcon}
                      selected={selectedPackage}
                      label="Choose Package"
                      onChange={getAss}
                      placeHolder="Choose Package"
                      isLoading={isLoadingPackage && stepNotPage === 3}
                  />

                  <DefaultSelect
                      key={'four'}
                      isDisabled={stepNotPage < 4}
                      data={selectAssessment}
                      icon={AssessmentIcon}
                      selected={selectedAssessment}
                      label="Choose Assessment"
                      onChange={(e) => {
                        getCycles(e)
                        callOriginSources(e)
                      }}
                      placeHolder="Choose Assessment"
                      isLoading={isLoadingAssessment && stepNotPage === 4}
                  />

                  <DefaultSelect
                      key={'five'}
                      isDisabled={stepNotPage < 5}
                      data={selectCycle}
                      label="Choose Cycle"
                      placeHolder="Choose Cycle"
                      icon={AssessmentIcon}
                      selected={ selectCycle[0] }
                      onChange={callOriginSources}
                      activeSelects={activeCyclesLinks.length !== 0 ? activeCyclesLinks : [] }
                      isMultiple
                      isLoading={isLoadingCycle && stepNotPage === 5}
                  />

                  <DefaultSelect
                      key={'six'}
                      isDisabled={stepNotPage < 6}
                      data={selectOriginSource}
                      label="Choose Group Types"
                      placeHolder="Choose Group Types"
                      icon={AssessmentIcon}
                      selected={ selectOriginSource[0]}
                      onChange={originSourceSelectHandler}
                      activeSelects={selectedOriginSource?.length !== 0 ? selectedOriginSource : [] }
                      isMultiple
                      isLoading={isLoadingOriginSource && stepNotPage === 6}
                  />
                </FirstSelectGroupWrapper>
              </MainBodyWrapper>
              <ButtonDefS
                  onClick={!isLoading ? () => genCSV() : () => null}
                  style={{ maxWidth: '98px' }}
                  disabled={stepNotPage < 5 && isLoadingOriginSource}
              >
                {isLoading ? <Loader size={0.5} /> : 'Export'}
              </ButtonDefS>
            </div>
        );
      }
    }
  };

  return (
      <>
        <div style={{ padding: '100px 20px', maxWidth: '900px', margin: 'auto' }}>
          <TitleWrapperS>
            <h1>Raw Data</h1>
            <ButtonBorderedS
                style={{ maxWidth: '200px' }}
                onClick={() => history.push(ROUTE_PATH.admin)}
            >
              Go to the main page
            </ButtonBorderedS>
          </TitleWrapperS>

          {renderBody()}

          {errorText && <Alert text={errorText} />}
        </div>
      </>
  );
};
const TitleWrapperS = styled(PageTitleWrapperS)`
  justify-content: space-between;
  width: 100%;
`;

const MainBodyWrapper = styled.div`
  margin-bottom: 40px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const FirstSelectGroupWrapper = styled.div`
  display: flex;
  gap: 10px;
  width: 100%;
`;

